import { getGameLobbies } from "api/game-lobby/get-game-lobby";
import subscribeToStream from "api/utils/subscribe-to-stream";
import { GameLobbyType } from "models/GameLobbyType";

type SubscribeArgs = {
  onGameLobbiesUpdate: (lobbies: GameLobbyType[] | null) => void;
};
type CleanupFn = () => void;

export const subscribeToGameLobbiesStream = ({ onGameLobbiesUpdate }: SubscribeArgs): CleanupFn => {
  return subscribeToStream<GameLobbyType[]>({
    resourcePath: "/api/game-lobby/list/stream",
    fetchLatest: () => getGameLobbies(),
    parseMessage: (data) => data as GameLobbyType[],
    onUpdate: onGameLobbiesUpdate,
  });
};

export default subscribeToGameLobbiesStream;
